import { postWithJSON } from "./RequestService";

const createWageScheduleRequest = ({
  monthlyPayment: amount_per_month,
  schedule: schedule_type,
  paycheckAmount: amount_deducted_per_paycheck,
  debtorId: wage_debtor_id,
}) => {
  const payload = {
    wage_debtor_id,
    wage_schedule: {
      amount_per_month,
      schedule_type,
      amount_deducted_per_paycheck,
    },
  };

  const url = `/wage_debtors/${wage_debtor_id}/wage_schedule`;
  return postWithJSON(url, payload);
};

export default createWageScheduleRequest;
